import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import LazyImage from "../../shared/lazy-image";
import LuxuryCarsBrands from "../luxury-brands";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { Text } from "@cars24/turbo-web/lib/text";
import { LinkButton } from "@cars24/turbo-web/lib/link-button";
import UpArrow from "./images/up-right.svg";
import { Button } from "@cars24/turbo-web/lib/button";
import ArrowIcon from "./images/viewall-arrow.svg";
import { LEAD_FORM, STEP_NAMES } from "../../../constants/app-constants";
import { FUNNEL_CONFIG } from "../../../utils/funnel/steps.desktop";

const EliteHowItWorks = ({
    section,
    resetRegistrationDataConnect,
    setStepConnect,
    activateFirstStepConnect,
    activateLastStepConnect
}) => {
    const { tokens } = useTokens();
    const {pageSection = {} } = section || {};
    const { title = "How it works?",  sectionData = [] } = pageSection || {};
    const formConfig = FUNNEL_CONFIG[LEAD_FORM.DEFAULT_REVAMP];

    const scrollToTop = () => {
        if (window && window.document) {
            const body = document.getElementsByTagName("body")[0];
            if (body) {
                body.scrollIntoView();
            }
        }
    };

    const onViewMoreBrands = () => {
        scrollToTop();
        resetRegistrationDataConnect();
        setStepConnect({ currentStep: STEP_NAMES.Brand, tabs: formConfig.tabs });
        activateFirstStepConnect(false);
        activateLastStepConnect(false);
    };

    return (
        <div styleName={"styles.eliteHowItWorks"}>
            <div styleName={"styles.eliteHowItWorksWrapper"}>
                <Text
                    align="center"
                    as="p"
                    fontWeight="semibold"
                    size="650"
                    transform="none"
                    color={tokens.text_default_text_primary}
                >
                    {title}
                </Text>
                <div styleName={"styles.howItWorkText"}>
                    {
                        sectionData.length > 0 &&  sectionData.map((item, index) => (
                            <div key={`elite-how-it-works-${index}`}>
                                <div styleName={"styles.titleSubTextWrapper"}>
                                    <div>
                                        <Text
                                            align="left"
                                            as="span"
                                            fontWeight="semibold"
                                            size="300"
                                            transform="none"
                                            color="#9CA3AF"
                                        >
                                            <font/>0{index + 1}
                                        </Text>
                                        <Text
                                            align="left"
                                            as="h3"
                                            fontWeight="medium"
                                            size="500"
                                            transform="none"
                                            color={tokens.text_default_text_primary}
                                        >
                                            {item.title}
                                        </Text>
                                    </div>
                                    <div styleName={"styles.imgWrapper"}>
                                        <LazyImage src={item?.image?.url} alt={item?.image?.alternativeText} />
                                    </div>
                                </div>
                                <div styleName={"styles.linkText"}>
                                    <Text
                                        align="left"
                                        as="p"
                                        fontWeight="regular"
                                        size="350"
                                        transform="none"
                                        color={tokens.text_default_text_primary}
                                    >
                                        {item.subTitle}
                                    </Text>
                                    <LinkButton
                                        label={item.primaryCtaText}
                                        onClick={scrollToTop}
                                        suffixIcon={<img src={UpArrow} alt="arrow"/>}
                                        variant="black"
                                        preventDefaultBehaviour
                                    />
                                </div>
                            </div>
                        ))
                    }
                </div>
                <div styleName={"styles.allbrands"}>
                    <LuxuryCarsBrands title={"Pick your car brand"} brandsPerRow={8} brandsToShow={16} showAllBrands={false}/>
                    <div styleName={"styles.viewallBrands"}>
                        <Button
                            label={"View more brands"}
                            onClick={onViewMoreBrands}
                            size="large"
                            suffixIcon={<img src={ArrowIcon} alt="arrow"/>}
                            theme="default"
                            variant="tertiary"
                        />
                    </div>
                </div>
            </div>
        </div>

    );
};

EliteHowItWorks.propTypes = {
    section: PropTypes.object,
    resetRegistrationDataConnect: PropTypes.func,
    setStepConnect: PropTypes.func,
    activateFirstStepConnect: PropTypes.func,
    activateLastStepConnect: PropTypes.func
};

export default EliteHowItWorks;
